import request, { resolve, post, put } from '../api/request';
import consts from '../app/constants';
import { resolveRequest } from '../actions/request';
import DesignCommentsStore from '../stores/DesignCommentsStore';
import designComment from '../models/designComment';

// Remains until 'isLoading' is refactored out of DesignCommentsStore
let loadDesignCommentsXhr = null;

export function loadDesignComments(context, { designId, commentsUrl }) {
    const apiRequest = request('GET', commentsUrl, consts.DESIGN_COMMENTS_LOADED);

    context.dispatch(consts.DESIGN_COMMENTS_LOAD_START, { designId });

    if (loadDesignCommentsXhr) {
        loadDesignCommentsXhr.abort();
    }

    const promise = resolve(apiRequest)
        .then(response => {
            const comments = context
                .getStore(DesignCommentsStore)
                .getCollectionModel()
                .fromJSON(response);

            context.dispatch(consts.DESIGN_COMMENTS_LOAD_FINISH, { designId, comments });
        })
        .catch(e => {
            context.dispatch('DESIGN_COMMENTS_LOAD_ERROR');
            throw e;
        });

    // The test expect a promise, but returning a promise actually changes the semantic of the action and tells
    // fluxible to wait for the promise to be complete before executing the callback, which is not what we want
    // Returning an object containing the promise let us inspect the promise without changing the action behaviour
    return {
        _promise: promise,
    };
}

export function resetSelectedComment(context) {
    return Promise.resolve().then(response => {
        context.dispatch(consts.DESIGN_COMMENT_SELECTED, { comment: null });
    });
}

export function resetComments(context) {
    return Promise.resolve().then(() => {
        context.dispatch(consts.DESIGN_COMMENTS_CLEAR);
    });
}

export function selectDesignComment(context, { comment }) {
    return Promise.resolve().then(response => {
        context.dispatch(consts.DESIGN_COMMENT_SELECTED, { comment });
    });
}

export function deleteDesignComment(context, { comment, csrfToken }) {
    context.dispatch(consts.DESIGN_COMMENT_DELETE_START, { comment });

    if (!comment.links.delete) {
        return Promise.reject(new Error('Invalid attempt to delete comment'));
    }

    const apiRequest = request(
        'DELETE',
        comment.links.delete,
        consts.DESIGN_COMMENT_DELETE_FINISH
    ).set('X-Csrf-Token', csrfToken);

    return resolve(apiRequest)
        .then(response => {
            context.dispatch(consts.DESIGN_COMMENT_DELETE_FINISH, {
                comment: context
                    .getStore(DesignCommentsStore)
                    .getModel()
                    .fromJSON(response),
            });
        })
        .catch(e => {
            context.dispatch(consts.DESIGN_COMMENT_DELETE_ERROR, e);
        });
}

export function createDesignComment(context, { comment, design, csrfToken }) {
    context.dispatch(consts.DESIGN_COMMENT_CREATE_START, { comment });
    const requestData = {
        message: comment.message,
    };

    if (comment.annotation) {
        requestData.annotationX = comment.annotation.x;
        requestData.annotationY = comment.annotation.y;
    }

    const apiRequest = post(design.links.createComment, consts.DESIGN_COMMENT_CREATE_FINISH)
        .set('X-Csrf-Token', csrfToken)
        .send(requestData);

    return context
        .executeAction(resolveRequest, { request: apiRequest })
        .then(response => {
            context.dispatch(consts.DESIGN_COMMENT_CREATE_FINISH, {
                comment: context
                    .getStore(DesignCommentsStore)
                    .getModel()
                    .fromJSON(response),
            });
        })
        .catch(e => {
            context.dispatch(consts.DESIGN_COMMENT_CREATE_ERROR, e);
        });
}

export function editDesignComment(context, { comment, editingLocation }) {
    return Promise.resolve().then(() => {
        context.dispatch(consts.DESIGN_COMMENT_EDIT_START, { comment, editingLocation });
    });
}

export function cancelEditDesignComment(context, { comment }) {
    return Promise.resolve().then(() => {
        context.dispatch(consts.DESIGN_COMMENT_EDIT_CANCEL, { comment: comment });
    });
}

export function updateDesignComment(context, { comment, csrfToken }) {
    const apiRequest = put(comment.links.edit)
        .set('X-Csrf-Token', csrfToken)
        .send(comment);

    // FIXME: find what UI changes are hinged on DESIGN_COMMENT_UPDATE_{START|FINISH}
    // use API_REQUEST_START and API_REQUEST_END instead for consistency and removing
    // bloat from DesignCommentsStore
    return Promise.resolve()
        .then(() => {
            context.dispatch(consts.DESIGN_COMMENT_UPDATE_START, { comment });
        })
        .then(() => resolve(apiRequest))
        .then(response => {
            context.dispatch(consts.DESIGN_COMMENT_UPDATE_FINISH, {
                comment: context
                    .getStore(DesignCommentsStore)
                    .getModel()
                    .fromJSON(response),
            });
        })
        .catch(e => {
            context.dispatch(consts.DESIGN_COMMENT_UPDATE_FINISH, { comment });
            throw e;
        });
}

export function enterDesignComment(context, { activeUser, position }) {
    const comment = designComment.create({
        creator: activeUser,
        annotation: position,
    });

    context.dispatch('DESIGN_COMMENT_ENTER_START', { comment });
}

export function cancelEnterDesignComment(context, payload, done) {
    context.dispatch('DESIGN_COMMENT_ENTER_CANCEL');
    done();
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/actions/design-comments.js